

const getReceiptLineItem = (invoices, receiptId) => {
  let lineItem;
  invoices.forEach(invoice => {
    invoice.lineItems.forEach(item => {
      if (item.receiptId === receiptId) {
        lineItem = item;
      }
    });
  });

  return lineItem;
};

const reduceReceiptMetrics = (invoices, receipts) =>
  receipts.reduce((metric, receipt) => {
    const lineItem = getReceiptLineItem(invoices, receipt.id);

    if (lineItem) {
      metric.invoicedTotal += Number(lineItem.total);
    } else {
      metric.receiptsToInvoice++;
      metric.notInvoicedTotal += Number(receipt.charged);
    }

    return metric;
  },
  {
    receiptsToInvoice: 0,
    invoicedTotal: 0,
    notInvoicedTotal: 0
  });

export const selectReceiptMetrics = (store) => {
  const invoices = store.invoicesState;
  const receipts = store.receiptsState.filter(receipt => receipt.type === "rebill");
  const metrics = reduceReceiptMetrics(invoices, receipts);

  return [
    {
      type: "horizontal",
      label: "Receipts to process",
      display: metrics.receiptsToInvoice,
    },
    {
      type: "vertical",
      label: "invoiced",
      display: `$${metrics.invoicedTotal.toFixed(2)}`,
    },
    {
      type: "vertical",
      label: "not invoiced",
      display: `$${metrics.notInvoicedTotal.toFixed(2)}`,
    },
  ];
}



// WEBPACK FOOTER //
// ./src/store/selectors/metrics/receipts.js